import React, { useState, useEffect, useContext } from "react";
import "./personalDetails.css";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { colors } from "@mui/material";
import successImg from "../../assets/images/userprofile/successImg.png";
import { useParams } from "react-router-dom";
import { axiosInstance_agent } from "../../axiosInstance-agent";
import { ToastContainer, toast } from "react-toastify";
import { useFormik } from "formik";
// import { axiosInstance } from "../../axiosInstance";
import { object, string } from "yup";
import * as Yup from "yup";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { axiosInstance_user } from "../../axiosInstance-user";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
// const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "image/jpg", "image/webp"];

// const PersonalSchema = Yup.object().shape({
// profile: Yup.mixed().test(
//   "is-valid-profile",
//   "You can only upload up to 5 images",
//   (value) => {
//     if (!value) return true;
//     if (typeof value === "string") return true; // Allow string URLs
//     if (Array.isArray(value)) return value.length <= 5;
//     return false;
//   }
// ),
//   caste: Yup.number()
//     .typeError("Select Caste") // for handling empty string
//     .required("Select Caste"),
// });
const PersonalSchema = (initialReligionName, initialCasteName, subcaste) =>
  Yup.object().shape({
    profile: Yup.mixed().test(
      "is-valid-profile",
      "You can only upload up to 3 images",
      (value) => {
        if (!value) return true;
        if (typeof value === "string") return true; // Allow string URLs
        if (Array.isArray(value)) return value.length <= 3;
        return false;
      }
    ),

    religion: Yup.string().required("Religion is required"),
    // from backend caste is mandatory field to select if religion is changed user should select caste
    caste: Yup.string().when("religion", {
      is: (religion) => religion !== initialReligionName,
      then: (schema) =>
        schema.required("Caste is required when religion is changed"),
      otherwise: (schema) => schema.notRequired(),
    }),
    //from backend subcaste is not mandatory even caste changed at that time passing ""
    sub_caste: Yup.string().when("caste", {
      is: (caste) =>
        caste &&
        caste !== initialCasteName &&
        subcaste[caste] &&
        subcaste[caste].length > 0, // only require if subcastes dropdown exist
      then: (schema) =>
        schema.required("Sub Caste is required when caste has subcastes"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
export function PersonalDetails() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [religion, setReligion] = useState([]);
  const [religionId, setReligionId] = useState();
  const [casteId, setCasteId] = useState();
  const [caste, setCaste] = useState([]);
  const [subcaste, setSubCaste] = useState([]);
  const [matchedReligionId, setMatchedReligionId] = useState(null);
  const [motherTongue, setMotherTongue] = useState([]);

  const [fileNames, setFileNames] = useState("Browse");
  const [imagePreviews, setImagePreviews] = useState([]);

  const params = useParams();
  const userid = params.id;

  const [selectedProfileFile, setSelectedProfileFile] = useState(null);
  const [profileImgPreview, setProfileImgPreview] = useState([]);
  // states to show error when ever state,religion,caste fields edited

  const [initialReligionName, setInitialReligionName] = useState("");
  const [initialCasteName, setInitialCasteName] = useState("");
  const formik = useFormik({
    initialValues: {
      profile: [],
      name: "",
      gender: "",
      dob: "",
      tob: "",
      pob: "",
      rashi: "",
      nakshatra: "",
      height: "",
      marital_status: "",
      religion: "",
      mother_tongue: "",
      caste: "",
      sub_caste: "",
      gotra: "",
      manglik: "",
      education: "",
      college_name: "",
      employed_in: "",
      organization_name: "",
      annual_income: "",
    },
    validationSchema: PersonalSchema(
      initialReligionName,
      initialCasteName,
      subcaste
    ),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        // getting id on user select so converting id into name
        // const selectedReligion = religion.find(
        //   (r) => r.id === Number(values.religion)
        // );
        // const selectedCaste = caste.find((c) => c.id === Number(values.caste));
        // const selectedSubCaste = subcaste.find(
        //   (s) => s.id === Number(values.sub_caste)
        // );
        // const selectedMotherTongue = motherTongue.find(
        //   (m) => m.id === Number(values.mother_tongue)
        // );
        const formData = new FormData();

        formData.append("name", values.name);
        formData.append("gender", values.gender);
        formData.append("dob", values.dob);
        formData.append("tob", values.tob);
        formData.append("pob", values.pob);
        formData.append("rashi", values.rashi);
        formData.append("nakshatra", values.nakshatra);
        formData.append("height", values.height);
        formData.append("marital_status", values.marital_status);
        formData.append("religion", values.religion || "");
        formData.append("mother_tongue", values.mother_tongue || "");
        formData.append("caste", values.caste || "");
        formData.append("sub_caste", values.sub_caste || "");
        formData.append("gotra", values.gotra);
        formData.append("manglik", values.manglik);
        formData.append("education", values.education);
        formData.append("college_name", values.college_name);
        formData.append("employed_in", values.employed_in);
        formData.append("organization_name", values.organization_name);
        formData.append("annual_income", values.annual_income);

        // Append file only if selected
        // if (selectedProfileFile) {
        //   formData.append("profile", selectedProfileFile);
        // }
        if (selectedProfileFile && selectedProfileFile.length > 0) {
          selectedProfileFile.forEach((file) => {
            formData.append("profile", file);
          });
        }

        const response = await axiosInstance_agent.patch(
          `admin/biodata/${userid}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.status === true) {
          handleOpen();
          setTimeout(() => {
            handleClose();
          }, 1000);
        } else {
          toast.error("Something went wrong, please try again!");
        }
      } catch (error) {
        setLoading(true);
        toast.error(error.response.data.message || "Submission failed!");
        console.error("Error saving to localStorage:", error);
      } finally {
        setLoading(false);
      }
    },
  });

  async function LoadUser(id) {
    try {
      const response = await axiosInstance_agent.get(`admin/biodata/${id}`);

      if (response.data.status === true || response.status === 200) {
        const user = response.data.data;
        // store initial Name's for validation schema

        setInitialReligionName(user.religion || "");
        setInitialCasteName(user.caste || "");

        // Find Caste ID from backend casteName
        // let prefillCasteId = null;
        // if (user.caste && caste.length > 0) {
        //   const matchedCaste = caste.find((c) => c.name === user.caste);
        //   prefillCasteId = matchedCaste ? matchedCaste.id : null;
        // }
        // if (prefillRelId) {
        //   LoadCaste(prefillRelId); // load caste list
        // }

        // if (prefillCasteId) {
        //   LoadSubCaste(prefillCasteId); // load sub caste list
        // }
        // destructure and set form values as before
        formik.setValues({
          profile: typeof user.profile === "string" ? [user.profile] : [],
          name: user.name || "",
          gender: user.gender || "",
          dob: user.dob || "",
          tob: user.tob || "",
          pob: user.pob || "",
          rashi: user.rashi || "",
          nakshatra: user.nakshatra || "",
          height: user.height ? parseFloat(user.height).toFixed(1) : "",
          marital_status: user.marital_status || "",
          religion: user.religion || "",
          mother_tongue: user.mother_tongue || "",
          caste: user.caste || "",
          sub_caste: user.sub_caste || "",
          gotra: user.gotra || "",
          manglik: user.manglik || "",
          education: user.education || "",
          college_name: user.college_name || "",
          employed_in: user.employed_in || "",
          organization_name: user.organization_name || "",
          annual_income: user.annual_income || "",
        });
        // ensure preview shows API image
        if (user.profile) {
          setProfileImgPreview([user.profile]);
        }
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch data");
      console.error("Error fetching user details", error);
    }
  }

  // load religion for prefill religion and also for formik value change
  useEffect(() => {
    if (religion.length > 0 && formik.values.religion) {
      const matched = religion.find((r) => r.name === formik.values.religion);
      if (matched) {
        LoadCaste(matched.id);
      }
    }
  }, [religion, formik.values.religion]);

  // load caste for prefill caste and also for formik value change
  useEffect(() => {
    if (caste.length > 0 && formik.values.caste) {
      const matched = caste.find((c) => c.name === formik.values.caste);
      if (matched) {
        LoadSubCaste(matched.id);
      }
    }
  }, [caste, formik.values.caste]);
  // useEffect(() => {
  //   if (matchedReligionId) {
  //     LoadCaste(matchedReligionId);
  //   }
  // }, [matchedReligionId]);

  // useEffect(() => {
  //   if (religion.length > 0 && params.id) {
  //     LoadUser(params.id);
  //   }
  // }, [religion, params.id]);
  useEffect(() => {
    if (userid) {
      LoadUser(userid);
    }
  }, [userid]);

  async function LoadReligion() {
    try {
      const response = await axiosInstance_user.get(
        "/dropdown/choices"
     
      );

      if (response.status === 200 && response.data) {
        console.log("religion", response.data.religion);
        setReligion(response.data.religion);
        setMotherTongue(response.data.mother_tongue);
      } else {
        console.error("Unexpected response format or status", response);
      }
    } catch (error) {
      console.error("Failed to load religion data:", error.message);
    }
  }

  async function LoadCaste(religionId) {
    try {
      const response = await axiosInstance_user.get(
        `/dropdown/caste/${religionId}`
      );
      const data = response.data;
      console.log("caste", data);
      setCaste(data);
    } catch (error) {
      console.error("Error loading caste list", error);
    }
  }

  // async function LoadCaste(matchedReligionId) {
  //   try {
  //     const response = await axios.get(
  //       `https://devapi.naticharami.in/api/v1/dropdown/caste/${matchedReligionId}`
  //       // `https://api.naticharami.in/api/v1/dropdown/caste/${matchedReligionId}`
  //     );
  //     const data = response.data;
  //     console.log("caste", data);
  //     setCaste(data);
  //   } catch (error) {
  //     console.error("Error loading caste list", error);
  //   }
  // }

  useEffect(() => {
    LoadReligion();
  }, []);

  // useEffect(() => {
  //   if (religionId) {
  //     LoadCaste(religionId);
  //   }
  // }, [religionId]);

  async function LoadSubCaste(casteId) {
    const response = await axiosInstance_user.get(
    
      `/dropdown/sub-caste/${casteId}`
    );
    const data = response.data;
    console.log("subcaste", data);
    setSubCaste(data);
  }
  // useEffect(() => {
  //   if (casteId) {
  //     LoadSubCaste(casteId);
  //   }
  // }, [casteId]);

  return (
    <>
      {/* <ToastContainer/> */}
      <form onSubmit={formik.handleSubmit}>
        {loading && (
          <div className="loader-overlay">
            <CircularProgress style={{ color: "#f24464" }} />
          </div>
        )}
        <div className="basicMainContainer">
          <div>
            {/* row 0 */}
            <div className="basicSubcontainer">
              {/* <div>
            <div className="lableName">
              Upload Photo: <span className="text-danger">*</span>
            </div>
            <div className="basicTextbox">
              <input type="file" style={{ padding: "7px" }}></input> Max size 5
              MB per image
            </div>
          </div> */}
              <div>
                <div className="lableName">Upload Photo </div>
                {/* <label for="fileInput" className="custom-file-label " >
              {fileNames}
            </label> */}

                {/* <input
              type="file"
              id="fileInput"
              class="custom-file-input"
              accept="image/*"
              multiple
              onChange={handleFileChange}
            /> */}
                <div className="basicTextbox">
                  <input
                    type="file"
                    multiple
                    style={{ padding: "7px" }}
                    id="profile"
                    name="profile"
                    accept="image/*"
                    // onChange={(e) => {
                    //   const files = Array.from(e.target.files);
                    //   if (files.length > 0) {
                    //     const imageUrls = files.map((file) =>
                    //       URL.createObjectURL(file)
                    //     );
                    //     setProfileImgPreview(imageUrls);
                    //     setSelectedProfileFile(files);
                    //   }
                    // }}
                    // onChange={(e) => {
                    //   const files = Array.from(e.target.files);
                    //   if (files.length > 0) {
                    //     const imageUrls = files.map((file) =>
                    //       URL.createObjectURL(file)
                    //     );
                    //     setProfileImgPreview(imageUrls);
                    //     setSelectedProfileFile(files);
                    //     formik.setFieldValue("profile", files);
                    //   } else {
                    //     formik.setFieldValue("profile", null);
                    //   }
                    // }}
                    onChange={(e) => {
                      const newFiles = Array.from(e.target.files);

                      if (newFiles.length > 0) {
                        // Merge old and new, but max 3
                        const updatedFiles = [
                          ...(selectedProfileFile || []),
                          ...newFiles,
                        ].slice(0, 3);

                        const imageUrls = updatedFiles.map((file) =>
                          URL.createObjectURL(file)
                        );

                        setProfileImgPreview(imageUrls);
                        setSelectedProfileFile(updatedFiles);
                        formik.setFieldValue("profile", updatedFiles);
                      }
                    }}
                    className={
                      formik.touched.profile && formik.errors.profile
                        ? "error"
                        : ""
                    }
                  ></input>{" "}
                </div>
                <div className="wallet-label">Can add upto 3 images</div>
                <div>
                  {formik.touched.profile && formik.errors.profile && (
                    <div className="text-danger">{formik.errors.profile}</div>
                  )}
                </div>
                <div className="image-preview-container">
                  {profileImgPreview &&
                    profileImgPreview.map((src, index) => (
                      <img
                        key={index}
                        src={src}
                        alt={`Preview ${index}`}
                        className="image-preview"
                      />
                    ))}
                </div>
              </div>
              {/* <div
                className="form-check form-switch d-flex align-items-center"
                style={{ marginLeft: "-35px" }}
              >
                <label
                  className="form-check-label lableName"
                  htmlFor="blurSwitch"
                >
                  {translations[language].blur_image}
                </label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="blurSwitch"
                  style={{
                    marginTop: "10px",
                    fontSize: "25px",
                    marginLeft: "20px",
                  }}
                />
              </div> */}
            </div>
            {/* row1 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">Full Name </div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    id="name"
                    onChange={formik.handleChange}
                    value={formik.values.name}
                    className={
                      formik.touched.name && formik.errors.name ? "error" : ""
                    }
                  ></input>
                  <div>
                    {formik.touched.name && formik.errors.name && (
                      <div className="text-danger">{formik.errors.name}</div>
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">Gender </div>

                <div>
                  <select
                    name="gender"
                    value={formik.values.gender}
                    onChange={formik.handleChange}
                    className={`dropdown-btnBasic ${
                      formik.touched.gender && formik.errors.gender
                        ? "error"
                        : ""
                    }`}
                  >
                    <option>Select</option>
                    <option>Female</option>
                    <option>Male</option>
                  </select>
                  <div>
                    {formik.touched.gender && formik.errors.gender && (
                      <div className="text-danger">{formik.errors.gender}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* row2 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">Date Of Birth</div>
                <div className="basicTextbox">
                  <input
                    type="date"
                    id="dob"
                    onChange={formik.handleChange}
                    value={formik.values.dob}
                    max={new Date().toISOString().split("T")[0]}
                    className={
                      formik.touched.dob && formik.errors.dob ? "error" : ""
                    }
                  ></input>
                  <div>
                    {formik.touched.dob && formik.errors.dob && (
                      <div className="text-danger">{formik.errors.dob}</div>
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">Time Of Birth</div>
                <div className="basicTextbox">
                  <input
                    type="time"
                    step="1" // enables seconds
                    id="tob"
                    onChange={formik.handleChange}
                    value={formik.values.tob}
                    onBlur={formik.handleBlur}
                    className={
                      formik.touched.tob && formik.errors.tob ? "error" : ""
                    }
                  />
                  <div>
                    {formik.touched.tob && formik.errors.tob && (
                      <div className="text-danger">{formik.errors.tob}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* row3 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">Place Of Birth</div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    id="pob"
                    onChange={formik.handleChange}
                    value={formik.values.pob}
                    className={
                      formik.touched.pob && formik.errors.pob ? "error" : ""
                    }
                  ></input>
                  <div>
                    {formik.touched.pob && formik.errors.pob && (
                      <div className="text-danger">{formik.errors.pob}</div>
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">Rashi</div>
                <div>
                  <div className="basicTextbox">
                    <select
                      name="rashi"
                      id="rashi"
                      value={formik.values.rashi}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.rashi && formik.errors.rashi
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="" disabled>
                        Select Rashi
                      </option>
                      <option>Mesham</option>
                      <option>Vrushabham</option>
                      <option>Midhunam</option>
                      <option>Karkatakam</option>
                      <option>Simham</option>
                      <option>Kanya</option>
                      <option>Tula</option>
                      <option>Vruschikam</option>
                      <option>Dhanussu</option>
                      <option>Makaram</option>
                      <option>Kumbham</option>
                      <option>Meenam</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* row4 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">Nakshatra</div>
                <div>
                  <div className="basicTextbox">
                    <select
                      name="nakshatra"
                      id="nakshatra"
                      value={formik.values.nakshatra}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.nakshatra && formik.errors.nakshatra
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="" disabled>
                        Select Nakshatra
                      </option>
                      <option>Anuraadha</option>
                      <option>Arudra</option>
                      <option>Ashlesha</option>
                      <option>Ashwini</option>
                      <option>Bharani</option>
                      <option>Chittaa</option>
                      <option>Dhanishta</option>
                      <option>Asthami</option>
                      <option>Jyesthaa</option>
                      <option> Kritika</option>
                      <option> Maghaa</option>
                      <option>Mula</option>
                      <option> Mrigasiraa</option>
                      <option>Punarvasu</option>
                      <option>Poorvashaadha</option>
                      <option> Poorvabhadraa</option>
                      <option>Pubba</option>
                      <option>Pushya</option>
                      <option> Revati</option>
                      <option>Rohini</option>
                      <option>Shatabhisha</option>
                      <option>Shravana</option>
                      <option>Swaati</option>
                      <option>Uttarashaadha</option>
                      <option> Uttaraa bhadra</option>
                      <option>Uttara</option>
                      <option>Vishaakha</option>
                    </select>
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">Height </div>
                <div>
                  {/* <select className="dropdown-btnBasic">
                
                <option>Select</option>
                <option>--</option>
              </select> */}
                  <div className="basicTextbox">
                    <select
                      name="height"
                      id="height"
                      value={formik.values.height}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.height && formik.errors.height
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="" disabled>
                        Select Height
                      </option>
                      <option value="4.0">4.0</option>
                      <option value="4.1">4.1</option>
                      <option value="4.2">4.2</option>
                      <option value="4.3">4.3</option>
                      <option value="4.4">4.4 </option>
                      <option value="4.5">4.5 </option>
                      <option value="4.6">4.6</option>
                      <option value="4.7">4.7 </option>
                      <option value="4.8">4.8 </option>
                      <option value="4.9">4.9 </option>
                      <option value="4.10">4.10</option>
                      <option value="4.11">4.11</option>
                      <option value="5.0">5.0 </option>
                      <option value="5.1">5.1 </option>
                      <option value="5.2">5.2 </option>
                      <option value="5.3">5.3 </option>
                      <option value="5.4">5.4 </option>
                      <option value="5.5">5.5 </option>
                      <option value="5.6">5.6 </option>
                      <option value="5.7">5.7 </option>
                      <option value="5.8">5.8 </option>
                      <option value="5.9">5.9 </option>
                      <option value="5.10">5.10 </option>
                      <option value="5.11">5.11 </option>
                      <option value="6.0">6.0 </option>
                      <option value="6.1">6.1 </option>
                      <option value="6.2">6.2 </option>
                      <option value="6.3">6.3 </option>
                      <option value="6.4">6.4 </option>
                      <option value="6.5">6.5 </option>
                      <option value="6.6">6.6 </option>
                      <option value="6.7">6.7 </option>
                      <option value="6.8">6.8 </option>
                      <option value="6.9">6.9 </option>
                      <option value="6.10">6.10</option>
                      <option value="6.11">6.11</option>
                      <option value="7.0">7.0 </option>
                      <option value="7.1">7.1 </option>
                      <option value="7.2">7.2 </option>
                      <option value="7.3">7.3 </option>
                      <option value="7.4">7.4 </option>
                      <option value="7.5">7.5 </option>
                      <option value="7.6">7.6 </option>
                      <option value="7.7">7.7 </option>
                      <option value="7.8">7.8 </option>
                      <option value="7.9">7.9 </option>
                      <option value="7.10">7.10 </option>
                      <option value="7.11">7.11 </option>
                    </select>
                    <div>
                      {formik.touched.height && formik.errors.height && (
                        <div className="text-danger">
                          {formik.errors.height}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row5 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">Marital Status</div>
                <div>
                  {/* <select className="dropdown-btnBasic"
              name="marital_status"
              onChange={formik.handleChange}
              value={formik.values.marital_status}
              >
               
                <option>Select</option>
                <option>---</option>
              </select> */}
                  <div className="basicTextbox">
                    <input
                      type="text"
                      id="marital_status"
                      onChange={formik.handleChange}
                      value={formik.values.marital_status}
                    ></input>
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">Religion</div>
                <div>
                  {/* <select className="dropdown-btnBasic">
                
                <option>Select</option>
                <option>---</option>
              </select> */}
                  <div className="basicTextbox">
                    <select
                      name="religion"
                      id="religion"
                      value={formik.values.religion} // will now hold name e.g. "Hindu"
                      onChange={(e) => {
                        const selectedName = e.target.value;
                        formik.setFieldValue("religion", selectedName);

                        // find ID to load caste
                        const matched = religion.find(
                          (r) => r.name === selectedName
                        );
                        if (matched) {
                          setReligionId(matched.id);
                        }
                        // reset caste & sub caste whenever religion changes
                        formik.setFieldValue("caste", "");
                        formik.setFieldValue("sub_caste", "");
                        setCaste([]);
                        setSubCaste([]);
                      }}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.religion && formik.errors.religion
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="">Select Religion</option>
                      {religion.map((list) => (
                        <option value={list.name} key={list.id}>
                          {list.name}
                        </option>
                      ))}
                    </select>

                    <div>
                      {formik.touched.religion && formik.errors.religion && (
                        <div className="text-danger">
                          {formik.errors.religion}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row6 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">Mother Tongue </div>
                <div>
                  {/* <select className="dropdown-btnBasic">
             
                <option>Select</option>
                <option>type 1</option>
                <option>type 2</option>
              </select> */}
                  <div className="basicTextbox">
                    <select
                      name="mother_tongue"
                      id="mother_tongue"
                      value={formik.values.mother_tongue} // will hold name
                      onChange={(e) => {
                        formik.setFieldValue("mother_tongue", e.target.value);
                      }}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.mother_tongue &&
                        formik.errors.mother_tongue
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="">Select Mother Tongue</option>
                      {motherTongue.map((list) => (
                        <option value={list.name} key={list.id}>
                          {list.name}
                        </option>
                      ))}
                    </select>

                    <div>
                      {formik.touched.mother_tongue &&
                        formik.errors.mother_tongue && (
                          <div className="text-danger">
                            {formik.errors.mother_tongue}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">Caste</div>
                <div>
                  {/* <select className="dropdown-btnBasic">
              
                <option>Select</option>
                <option>type 2</option>
              </select> */}
                  <div className="basicTextbox">
                    {/* <input
                      type="text"
                      id="caste"
                      onChange={formik.handleChange}
                      value={formik.values.caste}
                    ></input> */}
                    <select
                      name="caste"
                      id="caste"
                      value={formik.values.caste} // will hold name e.g. "Brahmin"
                      onChange={(e) => {
                        const selectedName = e.target.value;
                        formik.setFieldValue("caste", selectedName);

                        const matched = caste.find(
                          (c) => c.name === selectedName
                        );
                        if (matched) {
                          setCasteId(matched.id);
                        }
                        // reset sub caste whenever caste changes
                        formik.setFieldValue("sub_caste", "");

                        setSubCaste([]);
                      }}
                      onBlur={formik.handleBlur}
                      className={`dropdown-btnBasic ${
                        formik.touched.caste && formik.errors.caste
                          ? "error"
                          : ""
                      }`}
                    >
                      <option value="">Select Caste</option>
                      {caste.map((list) => (
                        <option value={list.name} key={list.id}>
                          {list.name}
                        </option>
                      ))}
                    </select>

                    {/* <div className="text-danger">Select Caste</div> */}
                    <div className="text-danger">
                      {formik.touched.caste && formik.errors.caste && (
                        <div className="error">{formik.errors.caste}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row7 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">Sub Caste</div>
                <div className="basicTextbox">
                  {/* <input
                    type="text"
                    placeholder="Enter sub caste"
                    id="sub_caste"
                    onChange={formik.handleChange}
                    value={formik.values.sub_caste}
                  ></input> */}
                  <select
                    name="sub_caste"
                    id="sub_caste"
                    value={formik.values.sub_caste} // will hold name
                    onChange={(e) => {
                      formik.setFieldValue("sub_caste", e.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.sub_caste && formik.errors.sub_caste
                        ? "error"
                        : ""
                    }`}
                  >
                    <option value="">Select Sub Caste</option>
                    {subcaste.map((list) => (
                      <option value={list.name} key={list.id}>
                        {list.name}
                      </option>
                    ))}
                  </select>

                  <div>First Select Caste</div>
                </div>
              </div>
              <div>
                <div className="lableName">Gothram</div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    placeholder="Enter Gothram"
                    id="gotra"
                    onChange={formik.handleChange}
                    value={formik.values.gotra}
                  ></input>
                </div>
              </div>
            </div>

            {/* row8 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">Manglik</div>
                <div>
                  {/* <select className="dropdown-btnBasic">
               
                <option>Select</option>
                <option>type 1</option>
              </select> */}
                  <div className="basicTextbox">
                    <input
                      type="text"
                      id="manglik"
                      onChange={formik.handleChange}
                      value={formik.values.manglik}
                      placeholder="Enter Manglik"
                    ></input>
                  </div>
                </div>
              </div>
              <div>
                <div className="lableName">Education</div>
                <div>
                  {/* <select className="dropdown-btnBasic">
            
                <option>Select</option>
                <option>type 1</option>
              </select> */}
                  <div className="basicTextbox">
                    <input
                      type="text"
                      id="education"
                      onChange={formik.handleChange}
                      value={formik.values.education}
                      placeholder="Enter Education"
                    ></input>
                  </div>
                </div>
              </div>
            </div>
            {/* row9 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">College Name</div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    placeholder="Enter College name"
                    id="college_name"
                    value={formik.values.college_name}
                    onChange={formik.handleChange}
                  ></input>
                </div>
              </div>
              <div>
                <div className="lableName">Employee Designation</div>
                <div>
                  {/* <select className="dropdown-btnBasic">
               
                <option>Select</option>
                <option>type 1</option>
              </select> */}
                  <div className="basicTextbox">
                    <input
                      type="text"
                      id="employed_in"
                      onChange={formik.handleChange}
                      value={formik.values.employed_in}
                      placeholder="Enter Employee Designation"
                    ></input>
                  </div>
                </div>
              </div>
            </div>
            {/* row10 */}
            <div className="basicSubcontainer">
              <div>
                <div className="lableName">Organization Name</div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    placeholder="Enter Organization name"
                    value={formik.values.organization_name}
                    onChange={formik.handleChange}
                    id="organization_name"
                  ></input>
                </div>
              </div>
              <div>
                <div className="lableName">Annual Income</div>
                <div>
                  {/* <select className="dropdown-btnBasic">
            
                <option>Select</option>
                <option>type 1</option>
              </select> */}
                  <div className="basicTextbox">
                    <input
                      type="text"
                      id="annual_income"
                      onChange={formik.handleChange}
                      value={formik.values.annual_income}
                      placeholder="Enter Annual Income"
                    ></input>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="btnBasicSave">
              <Button type="submit">Save Changes</Button>
              {/* <Button onClick={handleOpen} type="submit">Save Changes</Button> */}
            </div>

            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open}
              onClose={handleClose} //close modal on background click
              closeAfterTransition
            >
              <Fade in={open}>
                <Box sx={style} className="modal-box">
                  <img srcSet={successImg} />
                  <Typography
                    id="transition-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    Thank You
                  </Typography>
                  <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                    Personal Details has been updated successfully
                  </Typography>
                </Box>
              </Fade>
            </Modal>
          </div>
        </div>
      </form>
    </>
  );
}
